/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercise: NonNullable<unknown>, setsRemoved: NonNullable<unknown> }} Progression_Feedback_Too_LongInputs */

const en_us2_progression_feedback_too_long = /** @type {(inputs: Progression_Feedback_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Too long: ${i?.exercise} loses ${i?.setsRemoved} set`)
};

const pt_br2_progression_feedback_too_long = /** @type {(inputs: Progression_Feedback_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Longo demais: ${i?.exercise} perde ${i?.setsRemoved} série`)
};

const es_419_progression_feedback_too_long = /** @type {(inputs: Progression_Feedback_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Demasiado largo: ${i?.exercise} pierde ${i?.setsRemoved} serie`)
};

const pt_pt2_progression_feedback_too_long = /** @type {(inputs: Progression_Feedback_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Demasiado longo: ${i?.exercise} perde ${i?.setsRemoved} série`)
};

const fr_fr2_progression_feedback_too_long = /** @type {(inputs: Progression_Feedback_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trop long : ${i?.exercise} perd ${i?.setsRemoved} série`)
};

const de_de2_progression_feedback_too_long = /** @type {(inputs: Progression_Feedback_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zu lang: ${i?.exercise} verliert ${i?.setsRemoved} Satz`)
};

const it_it2_progression_feedback_too_long = /** @type {(inputs: Progression_Feedback_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Troppo lunga: ${i?.exercise} perde ${i?.setsRemoved} serie`)
};

/**
* | output |
* | --- |
* | "Too long: {exercise} loses {setsRemoved} set" |
*
* @param {Progression_Feedback_Too_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_feedback_too_long = /** @type {((inputs: Progression_Feedback_Too_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Feedback_Too_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_feedback_too_long(inputs)
	if (locale === "es-419") return es_419_progression_feedback_too_long(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_feedback_too_long(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_feedback_too_long(inputs)
	if (locale === "de-DE") return de_de2_progression_feedback_too_long(inputs)
	if (locale === "it-IT") return it_it2_progression_feedback_too_long(inputs)
	return en_us2_progression_feedback_too_long(inputs)
});
export { progression_feedback_too_long as "progression.feedback_too_long" }